module.exports = __webpack_public_path__ + "static/sec8-bg-741702472a8d25ea6fc89bc1f2a6ae61.jpg";